import React, { useEffect, useState, useRef } from "react";
import Slider from "react-slick";
import axios from "../axios";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Banner.css"; // ✅ Import CSS for proper styling

const Banner = () => {
  const [banners, setBanners] = useState([]); // Store banners
  const sliderRef = useRef(null); // Reference to Slider component

  useEffect(() => {
    // Fetch banners from Django API
    axios.get(`${process.env.REACT_APP_API_URL}api/banners/`)

      .then((response) => {
        setBanners(response.data);
      })
      .catch((error) => {
        console.error("Error fetching banners:", error);
      });
  }, []);

  // Slick settings
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000, // ✅ Pause duration: 5 seconds
    ref: sliderRef,
    adaptiveHeight: true, // ✅ Adjust height dynamically
  };

  return (
    <div className="banner-wrapper"> {/* ✅ Wrapper for border & shadow */}
      <div className="banner-container"> {/* ✅ Ensures proper width and alignment */}
        <Slider {...settings}>
          {banners.length > 0 ? (
            banners.map((banner, index) => (
              <div key={index} className="banner-slide"> {/* ✅ Prevents overflow */}
                {/* Check if the file is an image or video */}
                {banner.file_type === "image" ? (
                  <img src={banner.file_url} alt={`Banner ${index + 1}`} className="banner-image" />
                ) : banner.file_type === "video" ? (
                  <video
                    className="banner-video"
                    autoPlay
                    muted
                    loop
                    playsInline
                  >
                    <source src={banner.file_url} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                ) : (
                  <p>Unsupported file format</p>
                )}
              </div>
            ))
          ) : (
            <p>Loading banners...</p> // Show loading text if banners are not yet loaded
          )}
        </Slider>
      </div>
    </div>
  );
  
};

export default Banner;
